var POIConditionFormModel = /** @class */ (function () {
    function POIConditionFormModel() {
        this.poiSubCategoryId = null;
        this.type = null;
        this.condition = 'greater';
        this.value = null;
        this.valueIds = [];
        this.idsAndNames = [];
    }
    POIConditionFormModel.assign = function () {
        return new POIConditionFormModel();
    };
    POIConditionFormModel.prototype.removeSubcategoryValue = function (subcategoryValueId) {
        var removeSubcategoryValueIdx = this.valueIds.findIndex(function (id) { return subcategoryValueId === id; });
        var removeSubcategoryidAndNameIdx = this.idsAndNames.findIndex(function (idAndName) { return idAndName.id === subcategoryValueId; });
        this.valueIds.splice(removeSubcategoryValueIdx, 1);
        this.idsAndNames.splice(removeSubcategoryidAndNameIdx, 1);
    };
    POIConditionFormModel.prototype.addSubCateoryValue = function (ids, subCategoryValues) {
        this.valueIds = ids;
        this.idsAndNames = ids.map(function (id) {
            var selectedSubCategoryValueLabel = subCategoryValues.find(function (poiSubCategory) {
                return poiSubCategory.value === id;
            });
            return IdAndNameFormModel.assign({
                id: id,
                name: (selectedSubCategoryValueLabel === null || selectedSubCategoryValueLabel === void 0 ? void 0 : selectedSubCategoryValueLabel.valueLabel) === undefined
                    ? ''
                    : selectedSubCategoryValueLabel === null || selectedSubCategoryValueLabel === void 0 ? void 0 : selectedSubCategoryValueLabel.valueLabel,
            });
        });
    };
    return POIConditionFormModel;
}());
export { POIConditionFormModel };
var IdAndNameFormModel = /** @class */ (function () {
    function IdAndNameFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, name = _a.name;
        this.id = id;
        this.name = name;
    }
    IdAndNameFormModel.assign = function (data) {
        return new IdAndNameFormModel(data);
    };
    return IdAndNameFormModel;
}());
export { IdAndNameFormModel };
